export const capitalizeFirstLetter = (word: string): string => `${word[0].toUpperCase()}${word.slice(1)}`;

export const formatNumber = (num: number | undefined | null): string => {
  if (num === undefined || num === null) return "0";
  // Round to 2 decimal places first to avoid floating point issues
  const rounded = Math.round(num * 100) / 100;
  // Split into integer and decimal parts
  const parts = rounded.toString().split(".");
  // Format integer part with spaces
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  // Return with decimal part if it exists and is not .00
  if (parts[1] && parts[1] !== "00") {
    return parts.join(".");
  }
  return parts[0];
};
